// src/pages/storePages/manageStore/DeleteProductDialog.jsx
import { useEffect, useRef, useState } from "react";
import "../../../static/storecss/manageStore/DeleteProductDialog.css";

export default function DeleteProductDialog({
  open,
  product,
  onClose,
  onConfirm,
}) {
  const dialogRef = useRef(null);
  const inputRef = useRef(null);

  const [confirmText, setConfirmText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const expected = product?.name ?? "";
  const matches =
    confirmText.trim() === expected.trim() && expected.trim().length > 0;

  // Open / close the native <dialog>
  useEffect(() => {
    const dlg = dialogRef.current;
    if (!dlg) return;

    if (open && !dlg.open) {
      dlg.showModal();
      requestAnimationFrame(() => inputRef.current?.focus());
    } else if (!open && dlg.open) {
      dlg.close();
    }
  }, [open]);

  // Reset when opened or target changes
  useEffect(() => {
    if (open) {
      setConfirmText("");
      setSubmitting(false);
    }
  }, [open, product?.id]);

  const handleBackdropClick = (e) => {
    if (e.target === dialogRef.current && !submitting) {
      onClose?.();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting || !matches || !product) return;

    setSubmitting(true);
    try {
      await onConfirm?.(product);
      onClose?.();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <dialog
      ref={dialogRef}
      className="mpd-dialog"
      onClick={handleBackdropClick}
      aria-labelledby="mpd-title"
    >
      <form className="mpd-form" onSubmit={handleSubmit}>
        <div className="mpd-body">
          <div className="mpd-icon">
            <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
          </div>

          <div className="mpd-text">
            <h2 id="mpd-title">Delete product</h2>
            <p>
              This will permanently delete <strong>{product?.name}</strong> and
              all of its images and specifications. This action cannot be undone.
            </p>
          </div>
        </div>

        <div className="mpd-field">
          <label htmlFor="mpd-input">
            Type <strong>{product?.name}</strong> to confirm
          </label>
          <input
            ref={inputRef}
            id="mpd-input"
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder={product?.name ?? ""}
            autoComplete="off"
            spellCheck={false}
            disabled={submitting}
          />
        </div>

        <footer className="mpd-footer">
          <button
            type="button"
            className="mpd-btn mpd-btn--secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="mpd-btn mpd-btn--danger"
            disabled={!matches || submitting}
          >
            {submitting ? "Deleting…" : "Delete product"}
          </button>
        </footer>
      </form>
    </dialog>
  );
}